import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_13667)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M28.1933 12.7094C28.1359 12.5729 28.0394 12.4564 27.916 12.3747C27.7925 12.2929 27.6476 12.2495 27.4995 12.25H12.4995C12.3515 12.2495 12.2066 12.2929 12.0831 12.3747C11.9597 12.4564 11.8632 12.5729 11.8058 12.7094C11.7518 12.8479 11.738 12.9989 11.7662 13.1449C11.7945 13.2909 11.8634 13.4259 11.9652 13.5344L19.4652 21.0344C19.6085 21.173 19.8001 21.2505 19.9995 21.2505C20.1989 21.2505 20.3906 21.173 20.5339 21.0344L28.0339 13.5344C28.1357 13.4259 28.2046 13.2909 28.2328 13.1449C28.261 12.9989 28.2473 12.8479 28.1933 12.7094Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_13667",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgSelectIcon;
